import React from 'react';

import Layout from './layout';

function PageStatic(props) {
  return <Layout {...props} />;
}

export default PageStatic;
